export default __webpack_public_path__ + "static/OpenSans-Regular-ce3c9038384a26f6bc163f6b5a9710c4.woff2";